import React from "react";
import CategoryComponent from "../../components/CategoryComponent";
import Data from "../../Data/Categories/TapingEnergetico";
import { Helmet } from "react-helmet-async";
function TapingEnergetico({ footer = true }) {
  return <CategoryComponent data={Data} footer={footer} />;
}

export default TapingEnergetico;
